import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateAdminRoute from './components/PrivateAdminRoute';
import HubMarketplace from './pages/HubMarketplace';
import HubCheckout from './pages/HubCheckout';
import HubCheckoutReturn from './pages/HubCheckoutReturn';
import HubSubscriptions from './pages/HubSubscriptions';
import HubPlansAdmin from './pages/HubPlansAdmin';
import LoginAdmin from './pages/LoginAdmin';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/*
          Rotas do checkout — vindas de redirect assinado do HUB.
          O HUB monta ${PORTAL_URL}/hub/marketplace?tenantId=..&signature=..
          (rota hardcoded no HUB — ver PLAN.md seção 1). Manter todas as
          internas com prefixo /hub/ pra consistência com URLs internas
          já usadas dentro das páginas (navigate('/hub/subscriptions') etc.).
        */}
        <Route path="/hub/marketplace" element={<HubMarketplace />} />
        <Route path="/hub/checkout/:channel" element={<HubCheckout />} />
        <Route path="/hub/checkout/return" element={<HubCheckoutReturn />} />
        <Route path="/hub/subscriptions" element={<HubSubscriptions />} />

        {/* Admin — requer JWT do marketplace */}
        <Route path="/login-admin" element={<LoginAdmin />} />
        <Route
          path="/plans-admin"
          element={
            <PrivateAdminRoute>
              <HubPlansAdmin />
            </PrivateAdminRoute>
          }
        />

        {/* Fallback: / → /hub/marketplace (entrada padrão) */}
        <Route path="/" element={<Navigate to="/hub/marketplace" replace />} />
        <Route path="*" element={<Navigate to="/hub/marketplace" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
